import enableAccordions from './accordion';
import enableNav from './nav';

(function ($) {
    $(document).ready(function() {
      setTimeout(function() {
        var $slides = $('.flexslider .slides li');
        var $minheight = 0;
        $slides.each(function() {
          var $slide = $('.caption', this);
          var $height = $slide[0].offsetHeight;
          if ($height > $minheight) {
            $minheight = $height;
          }
        });
        $slides.each(function() {
          var $slide = $('.caption', this);
          $slide.css({height: $minheight});
        });
      }, 500);
    });
  $(document).ready(function() {
    var duration = 300;

    // Dirty little hack to the search icon onto the top search bar
    $("#searchsubmit").attr('value', '\uf002')
                      .attr('style', 'font-family: \'FontAwesome\'');

    // pass it the ID or Class of the link
    var pullDownSearch = function() {
      if ($('.top-search').hasClass('open')) {
        $('.top-search').stop().slideUp(duration, function() {
          $('.overlay').stop().fadeOut(duration);
        });

        if ($("#searchbuttoncaret").hasClass('fa-angle-up')) {
          $("#searchbuttoncaret").removeClass('fa-angle-up').addClass('fa-angle-down');
        }
      } else {
        $('.overlay').stop().fadeIn(duration);
        $('.top-search').stop().slideDown(duration, function() {
          $('.subnav-container').removeClass('active').hide();
        });

        if ($("#searchbuttoncaret").hasClass('fa-angle-down')) {
          $("#searchbuttoncaret").removeClass('fa-angle-down').addClass('fa-angle-up');
        }
      }

      $('.top-search').toggleClass('open');
    }

    // Opens the top search bar
    $('#opensearch').on('click', function() {
      pullDownSearch();
      $("#s").focus();
      return false;
    });
    $('#closesearch').on('click', function() {
      pullDownSearch();
      return false;
    });

    // Closes the top search if the overlay is clicked
    $('.overlay').mousedown(function() {
      if ($('.top-search').hasClass('open')) {
        pullDownSearch();
        return false;
      }
    })

    // Navigation Dropdown links
    $('.sidebar-nav .toggle').on('click', function(event) {
      // Element is a span class or is part of the sub-nav so we ignore the dropdown click
      if (event.target.tagName.toLowerCase() === 'span' || $(event.target).closest('a').siblings('.sub-nav').length == 0) {
        return true;
      }

      if ($(this).hasClass('open')) {
        $(this).children('.sub-nav').stop().slideUp(duration);
      } else {
        $(this).children('.sub-nav').stop().slideDown(duration);

        var other = $(this).parent('ul').children('.open').not(this).not('.mobile-menu');
        other.children('a').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
        other.children('.sub-nav').stop().slideUp(duration);
        other.find('.open .sub-nav').stop().slideUp(duration);
        other.find('.open').children('a').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
        other.find('.open').removeClass('open');
        other.removeClass('open');
      }

      $(this).children('a').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
      $(this).toggleClass('open');
      return false;
    });

    // Mobile Menu
    $('.mobile-nav-toggle').on('click', function() {
      if ($('.mobile-nav-menu').hasClass('active')) {
        $('.mobile-nav-menu').removeClass('active').hide();

        $('.open-subnav').removeClass('active');
        $('.open-subnav i').removeClass('fa-times').addClass('fa-plus');
        $('.subnav').hide();

        $('i', this).removeClass('fa-times').addClass('fa-bars');
        $('body').attr('style', '');
      } else {
        $('.mobile-nav-menu').addClass('active').show();
        $('i', this).removeClass('fa-bars').addClass('fa-times');
        $('body').attr('style', 'overflow: hidden');

        if ($('.top-search').hasClass('open')) {
          pullDownSearch();
        }
      }

      return false;
    });

    // Opens the search bar on mobile
    $('.search-toggle').on('click', function() {
      if ($('.mobile-nav-menu').hasClass('active')) {
        $('.mobile-nav-menu').removeClass('active').hide();
        $('.open-subnav').removeClass('active');
        $('.open-subnav i').removeClass('fa-times').addClass('fa-plus');
        $('.mobile-nav-toggle > i').removeClass('fa-times').addClass('fa-bars');
        $('.subnav').hide();
      }

      pullDownSearch();
      return false;
    });

    // opens a sub nav, closes others that are open
    $('.mobile-nav .toggle').on('click', function(event) {
      if ((event.target.tagName.toLowerCase() === 'span' || $(event.target).siblings('.sub-nav').length == 0) && event.target.tagName.toLowerCase() !== 'i') {
        return true;
      }

      if ($(this).hasClass('open')) {
        $(this).children('.sub-nav').stop().slideUp(duration);
      } else {
        $(this).children('.sub-nav').stop().slideDown(duration);

        var other = $(this).parent('ul').children('.open').not(this);
        other.children('a').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
        other.children('.sub-nav').stop().slideUp(duration);
        other.find('.open .sub-nav').stop().slideUp(duration);
        other.find('.open').children('a').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
        other.find('.open').removeClass('open');
        other.removeClass('open');
      }

      $(this).children('a').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
      $(this).toggleClass('open');
      return false;
    });

  });

  $('select[name=filters]').on('change', function() {
    $(this).closest('.search_form').submit();
  });
  $('.search_form').on('submit', function(e) {
    var filters = $(this).find('select[name=filters]');
    if (filters.length) {
      filters = $(filters[0]);
      e.preventDefault();
      $('#filters').attr('name', filters.val().split('=')[0]);
      $('#filters').val(filters.val().split('=')[1]);
      $(filters).val('');
      this.submit();
    }
  });
  enableNav();
  enableAccordions();
})(jQuery);



/** WEBPACK FOOTER **
 ** ./src/assets/foi/js/script.js
 **/